import { useNavigate } from 'react-router';

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center">
      <main className="text-center p-8 flex flex-col items-center space-y-6">
        <h1 className="text-6xl md:text-7xl font-light tracking-tight">Gamgee</h1>
        <p className="text-xl md:text-2xl tracking-wide text-base-content/80">Analytics Intelligence</p>
        <button
          className="btn btn-soft rounded-full w-64 h-12 transition-all duration-600 text-lg md:text-xl font-light"
          onClick={() => navigate('/login')}
        >
          Get Started
        </button>
      </main>
    </div>
  );
}
